import React from "react";

function barColor(percentage: number): string {
  if (percentage >= 90) return "var(--color-error)";
  if (percentage >= 70) return "var(--color-warning)";
  return "var(--color-accent)";
}

/// `percentage: null` draws the track alone (uncapped, or not yet loaded), so
/// a row's height never depends on whether its resource has a ceiling.
export const QuotaProgressBar: React.FC<{
  percentage: number | null;
  size?: "sm" | "md";
}> = ({ percentage, size = "sm" }) => (
  <div
    className={`w-full ${size === "md" ? "h-1.25" : "h-0.75"} rounded-app overflow-hidden`}
    style={{ background: "var(--color-border)" }}
  >
    {percentage !== null && (
      <div
        className="h-full rounded-app"
        style={{
          width: `${Math.min(100, Math.max(0, percentage))}%`,
          background: barColor(percentage),
          transition: "width 200ms ease-in-out",
        }}
      />
    )}
  </div>
);
